export const getColorModeOptions = ({
  optionPrefix,
}: {
  optionPrefix: string;
}) => [
  {
    value: `${optionPrefix}same`,
    label: s__('Builder|Unique style'),
  },
  {
    value: `${optionPrefix}different`,
    label: s__('Builder|Custom'),
  },
];
